import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const CalculationDefaultsTab = ({ settings, onSettingChange }) => {
  const paymentFrequencyOptions = [
    { value: 'monthly', label: 'Monthly' },
    { value: 'quarterly', label: 'Quarterly' },
    { value: 'annual', label: 'Annual' }
  ];

  const compoundingOptions = [
    { value: 'monthly', label: 'Monthly' },
    { value: 'quarterly', label: 'Quarterly' },
    { value: 'annual', label: 'Annual' },
    { value: 'daily', label: 'Daily' }
  ];

  const amortizationOptions = [
    { value: 'normal', label: 'Normal Amortization' },
    { value: 'interest-only', label: 'Interest-Only' }
  ];

  return (
    <div className="space-y-8">
      <div>
        <h3 className="text-lg font-semibold text-foreground mb-4">Default Calculation Values</h3>
        <p className="text-sm text-text-secondary mb-6">Set default values that will be pre-filled in the loan calculator to streamline your workflow.</p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Input
            label="Default Loan Amount"
            type="number"
            placeholder="250000"
            value={settings.defaultLoanAmount}
            onChange={(e) => onSettingChange('defaultLoanAmount', e.target.value)}
            description="Default principal amount for new calculations"
          />
          
          <Input
            label="Default Annual Interest Rate (%)"
            type="number"
            step="0.01"
            placeholder="6.50"
            value={settings.defaultInterestRate}
            onChange={(e) => onSettingChange('defaultInterestRate', e.target.value)}
            description="Standard interest rate for your organization"
          />
          
          <Input
            label="Default Number of Payments"
            type="number"
            placeholder="360"
            value={settings.defaultPayments}
            onChange={(e) => onSettingChange('defaultPayments', e.target.value)}
            description="Total number of payments (e.g., 360 for 30-year monthly)"
          />
          
          <Input
            label="Default Points"
            type="number"
            step="0.01"
            placeholder="1.00"
            value={settings.defaultPoints}
            onChange={(e) => onSettingChange('defaultPoints', e.target.value)}
            description="Loan origination fees as percentage"
          />
        </div>
      </div>

      <div>
        <h3 className="text-lg font-semibold text-foreground mb-4">Calculation Preferences</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Select
            label="Default Payment Frequency"
            options={paymentFrequencyOptions}
            value={settings.paymentFrequency}
            onChange={(value) => onSettingChange('paymentFrequency', value)}
            description="How often payments are made"
          />
          
          <Select
            label="Default Compounding Method"
            options={compoundingOptions}
            value={settings.compoundingMethod}
            onChange={(value) => onSettingChange('compoundingMethod', value)}
            description="Interest compounding frequency"
          />
          
          <Select
            label="Default Amortization Type"
            options={amortizationOptions}
            value={settings.amortizationType}
            onChange={(value) => onSettingChange('amortizationType', value)}
            description="Type of loan amortization schedule"
            className="md:col-span-2"
          />
        </div>
      </div>

      <div>
        <h3 className="text-lg font-semibold text-foreground mb-4">Common Interest Rates</h3>
        <p className="text-sm text-text-secondary mb-4">Quick-select buttons for frequently used rates in your organization.</p>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          <Input
            label="Rate 1 (%)"
            type="number"
            step="0.01"
            placeholder="5.50"
            value={settings.quickRate1}
            onChange={(e) => onSettingChange('quickRate1', e.target.value)}
          />
          <Input
            label="Rate 2 (%)"
            type="number"
            step="0.01"
            placeholder="6.00"
            value={settings.quickRate2}
            onChange={(e) => onSettingChange('quickRate2', e.target.value)}
          />
          <Input
            label="Rate 3 (%)"
            type="number"
            step="0.01"
            placeholder="6.50"
            value={settings.quickRate3}
            onChange={(e) => onSettingChange('quickRate3', e.target.value)}
          />
          <Input
            label="Rate 4 (%)"
            type="number"
            step="0.01"
            placeholder="7.00"
            value={settings.quickRate4}
            onChange={(e) => onSettingChange('quickRate4', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default CalculationDefaultsTab;